package nl.volleyplanner.api.client

import kotlinx.browser.window
import kotlinx.coroutines.await
import kotlinx.serialization.json.Json
import nl.volleyplanner.api.files.ErrorFileUploadResponse
import nl.volleyplanner.api.files.FileUploadResponse
import org.w3c.fetch.*
import org.w3c.files.File
import org.w3c.xhr.FormData
import kotlin.js.json


class FileUploadException(
    message: String,
    val response: FileUploadResponse?
) : Exception(message)


class VolleyplannerApiFileUploadClient private constructor(
    private val organisationCode: String,
    private val defaultRequestSpec: ApiDefaultRequestSpec,
    private val tokenLoader: VolleyPlannerAuthTokenLoader
) {
    companion object {
        private val organisationMap = mutableMapOf<String, VolleyplannerApiFileUploadClient>()
        fun of(organisationCode: String, defaultRequestSpec: ApiDefaultRequestSpec, tokenLoader: VolleyPlannerAuthTokenLoader) =
            organisationMap.getOrPut(organisationCode,
                { VolleyplannerApiFileUploadClient(organisationCode, defaultRequestSpec, tokenLoader) })
    }

    suspend fun <T> uploadFile(fileType: String, file: File, responseCreator: (jsonText: String) -> T, customFields: Map<String, String> = emptyMap()) : T {
        val formData = FormData()
        formData.append("file_upload", file, filename = file.name)
        customFields.forEach { (key, value) -> formData.append(key, value) }

        val response = window.fetch(
            "${defaultRequestSpec.toUrlString()}/${organisationCode}/files/$fileType/upload",
            RequestInit(
                method = "POST",
                body = formData,
                mode = RequestMode.CORS,
                cache = RequestCache.NO_CACHE,
                credentials = RequestCredentials.SAME_ORIGIN,
                redirect = RequestRedirect.ERROR,
                keepalive = true,
                referrer = "about:client",
                referrerPolicy = js("undefined"),
                integrity = "",
                headers = json(
                    // TODO: Only refresh when necessary
                    "Authorization" to "Bearer ${tokenLoader.refreshTokens()!!.accessToken}"
                )
            )
        ).await()

        if (response.status >= 500.toShort()) {
            throw FileUploadException("Applicatie fout - neem contact op", null)
        }

        val jsonText = response.text().await()

        when (response.status) {
            200.toShort() -> return responseCreator(jsonText)
            400.toShort() -> throw FileUploadException("File upload failed", Json.decodeFromString<ErrorFileUploadResponse>(jsonText))
        }
        throw IllegalStateException("File upload request failed: ${response.status} - ${response.statusText}")
    }
}


